(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["magick-brush-recording"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__magickBrushReplaySetup || (window.Shopify && Shopify.designMode)) return;
  if (!/^(magickbrush\.com|www\.magickbrush\.com|pin3ai-wn\.myshopify\.com)$/.test(location.hostname)) return;
  if (!/^\/$|^\/(products|collections|cart)(\/|$)/.test(location.pathname)) return;
  if (/[?&](email|token|key|password|code)=/i.test(location.search)) return;
  window.__magickBrushReplaySetup = true;
  var mp, loading = false, active = false;
  var capture = {
    pageview: 'url-with-path', click: true, dead_click: true, rage_click: true,
    scroll: true, input: false, submit: false, capture_text_content: false,
    scroll_depth_percent_checkpoints: [25, 50, 75, 100],
    block_selectors: ['input', 'textarea', '[contenteditable="true"]', '.mp-sensitive', '.mp-no-track']
  };
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function sync() {
    if (!allowed()) {
      if (mp) {
        mp.stop_session_recording();
        mp.set_config({autocapture: false, record_heatmap_data: false, record_sessions_percent: 0});
        mp.opt_out_tracking();
      }
      active = false;
      return;
    }
    if (!mp) { load(); return; }
    if (active) return;
    mp.opt_in_tracking({track: null});
    mp.register({tracking_source: 'Magick Brush storefront replay', tracking_version: '2026-09-16.1'});
    mp.set_config({autocapture: capture, record_heatmap_data: true, record_sessions_percent: 100});
    mp.start_session_recording();
    active = true;
  }
  function load() {
    if (loading) return;
    loading = true;
    if (!window.mixpanel || typeof window.mixpanel.get_config !== 'function') {
    (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split('.');2==b.length&&((a=a[b[0]]),(d=b[1]));a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)));};}var a=b;'undefined'!==typeof c?(a=b[c]=[]):(c='mixpanel');a.people=a.people||[];a.toString=function(a){var d='mixpanel';'mixpanel'!==c&&(d+='.'+c);a||(d+=' (stub)');return d;};a.people.toString=function(){return a.toString(1)+'.people (stub)';};i='disable time_event track track_pageview track_links track_forms register register_once unregister identify set_config reset opt_in_tracking opt_out_tracking'.split(' ');for(h=0;h<i.length;h++)g(a,i[h]);b._i.push([e,f,c]);};b.__SV=1.2;e=f.createElement('script');e.type='text/javascript';e.async=true;e.src='https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';g=f.getElementsByTagName('script')[0];g.parentNode.insertBefore(e,g);}})(document,window.mixpanel||[]);
    }
    window.mixpanel.init('65b316b854899f246d5a6f84e43be7d3', {
      api_host: 'https://api.mixpanel.com',
      autocapture: false, record_sessions_percent: 0, record_heatmap_data: false,
      record_mask_all_text: true, record_mask_all_inputs: true,
      record_block_selector: 'img, video, iframe, input, textarea, [contenteditable="true"], .mp-sensitive, .mp-no-track',
      record_unmask_text_selector: 'header nav, main h1, main h2, main h3, main button',
      property_blacklist: ['$current_url', '$referrer', '$initial_referrer', 'current_url_search', '$current_url_search'],
      loaded: function(instance) { mp = instance; sync(); }
    }, 'magickBrushReplay');
  }
  document.addEventListener('visitorConsentCollected', sync);
  function ready() {
    if (!window.Shopify) return;
    if (Shopify.customerPrivacy) { sync(); return; }
    if (Shopify.loadFeatures) {
      Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function(error) { if (!error) sync(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["visual-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-size-guide')) {
    customElements.define('mb-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const updateSize = (button) => {
          const w = Number(button.dataset.width), h = Number(button.dataset.height);
          if (!(w > 0 && h > 0)) return;
          this.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          const scale = Math.min(6, 620 / w, 310 / h);
          this.querySelectorAll('[data-art],[data-art-back]').forEach(art => {
            art.setAttribute('width', w * scale); art.setAttribute('height', h * scale);
            art.setAttribute('x', (720 - w * scale) / 2); art.setAttribute('y', 360 - h * scale);
          });
          this.querySelectorAll('[data-furniture]').forEach(g => g.setAttribute('transform', `translate(${360*(1-scale/6)} ${570*(1-scale/6)}) scale(${scale/6})`));
          const cm = n => (Math.round(n * 25.4) / 10).toLocaleString(document.documentElement.lang);
          this.querySelector('[data-dimension]').textContent = `${w} × ${h} in · ${cm(w)} × ${cm(h)} cm`;
        };
        this.addEventListener('click', event => {
          const sizeButton = event.target.closest('[data-size]');
          if (sizeButton) updateSize(sizeButton);
          const roomButton = event.target.closest('[data-room]');
          if (roomButton) {
            const room = roomButton.dataset.room;
            this.querySelectorAll('[data-room]').forEach(b => b.setAttribute('aria-pressed', String(b === roomButton)));
            this.querySelectorAll('[data-furniture]').forEach(g => g.style.display = g.dataset.furniture === room ? '' : 'none');
            this.querySelectorAll('[data-room-caption]').forEach(c => c.hidden = c.dataset.roomCaption !== room);
          }
        });
        const first = this.querySelector('[data-size]');
        if (first) updateSize(first);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
